/* eslint-disable consistent-return */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component } from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import AsyncSelect from 'react-select/async';
import * as Service from '../../../services/AirportService';
import { getTimeZoneData } from '../../../infrastructure/utils/common';

class State {
  data = [];
  airports = [];
  selectValue = '';
  currentAirport = {};
  open = false;
}

export default class AirortSearcher extends Component {
  state = new State();

  componentDidMount() {
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { value } = this.props;
    this.setState({ selectValue: value });
  }
  getAirports = async val => {
    if (val === '') {
      this.setState({ selectValue: val });
      return;
    }
    this.setState({ selectValue: val });
    const data = await Service.getAirports(val);
    const res = data.map(elem => ({ label: elem.name, value: elem.name }));
    const airports = res.slice(0, 10);
    this.setState({ data });
    return airports;
  };

  inputChange = val => {
    this.setState({ selectValue: val });
  };

  setAirport = val => {
    if (!val.label) {
      return;
    }
    // TODO: Fix this the next time the file is edited.
    // @ts-ignore
    // eslint-disable-next-line react/prop-types
    const { onSelected } = this.props;
    const { data } = this.state;
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const currentAirport = data.find(el => el.name === val.label);
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    if (currentAirport.timezone === '\\N') {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      getTimeZoneData(currentAirport.latitude, currentAirport.longitude).then(
        info => {
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          currentAirport.timezone = info.data.timeZoneId;
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          currentAirport.offset = info.data.rawOffset / 3600;
          onSelected(currentAirport);
          this.setState({ selectValue: val.name });
        }
      );
    } else {
      onSelected(currentAirport);
      this.setState({ selectValue: val.name });
    }
  };

  render() {
    const { selectValue } = this.state;
    return (
      <AsyncSelect
        defaultOptions
        placeholder='Select an Airport'
        styles={{
          menu: styles => ({ ...styles, zIndex: 4000 }),
          control: styles => ({
            ...styles,
            '&:focus': {
              borderColor: '#4496d8',
              boxShadow: 'none',
              outline: '0',
            },
          }),
        }}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          ClearIndicator: () => null,
        }}
        loadOptions={this.getAirports}
        onChange={this.setAirport}
        inputValue={selectValue}
        onInputChange={this.inputChange}
      />
    );
  }
}
